const FEATURED_DEALERS_MODAL_ID = 'dealer-modal';
const FEATURED_DEALERS_TRIGGER_SELECTOR = 'a[href="#dealer-modal"]';

if (!window.__featuredDealersModalInitialized) {
  window.__featuredDealersModalInitialized = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(FEATURED_DEALERS_TRIGGER_SELECTOR);
    if (!(trigger instanceof HTMLAnchorElement)) return;

    const modal = document.getElementById(FEATURED_DEALERS_MODAL_ID);
    if (!modal || typeof modal.showDialog !== 'function') return;

    event.preventDefault();
    modal.showDialog();
  });
}
